import BounceIn from './bounce-in'
import BounceInLeft from './bounce-in-left'
import BounceInDown from './bounce-in-down'
import BounceInRight from './bounce-in-right'
import BounceInUp from './bounce-in-up'

export default {
  BounceIn,
  BounceInLeft,
  BounceInDown,
  BounceInRight,
  BounceInUp
}



// WEBPACK FOOTER //
// ./src/animates/animated-vue/transitions/bouncing-entrances/index.js